import { LOGIN_ROUTE } from "@/routing/app-routes";

/*
    baseRoute   -- route from this file
    pathParams  -- list of values to include in sequence
    queryParams -- list of objects containing key and value fields [{ key: <>, value: <>}]
*/
export const composeRoute = (baseRoute, pathParams, queryParams, hashlink) => {
  let composedRoute = "";
  let replace = false;
  for (let i = 0, j = 0; i < baseRoute.length; i++) {
    const char = baseRoute.charAt(i);
    if (char === ":") {
      if (pathParams && j < pathParams.length) {
        composedRoute += pathParams[j++];
      }
      replace = true;
    } else if (!replace) {
      composedRoute += char;
    } else if (char === "/") {
      composedRoute += char;
      replace = false;
    }
  }
  if (queryParams && queryParams.length) {
    composedRoute += "?";
    composedRoute = composeQueryParamString(queryParams, composedRoute);
  }
  if (hashlink) {
    composedRoute += `#${hashlink}`;
  }

  return composedRoute;
};

export const isMatchingPath = (pathname, slug) => {
  const slugParts = slug.toLowerCase().split("/");
  const pathnameParts = pathname.toLowerCase().split("/");

  if (slugParts.length !== pathnameParts.length) {
    return false;
  }

  for (let i = 0; i < slugParts.length; i++) {
    if (slugParts[i].startsWith(":")) {
      continue;
    }

    if (slugParts[i] !== pathnameParts[i]) {
      return false;
    }
  }

  return true;
};

export const composeQueryParamString = (queryParams, baseString) => {
  if (typeof queryParams === "string") {
    return queryParams;
  }
  let paramString = `${baseString}`;
  queryParams.forEach((querySet, index) => {
    paramString += `${index > 0 ? "&" : ""}${querySet.key}=${encodeURIComponent(querySet.value)}`;
  });
  return paramString;
};

export const composeQueryParamsFromMap = (theMap) => {
  const params = [];
  const iter = theMap.entries();
  for (const [key, value] of iter) {
    params.push({ key, value });
  }
  return params;
};

export const parseQueryString = (queryString, wantList = false) => {
  const dictionary = new Map();
  const queryList = [];

  if (!queryString) {
    return wantList ? queryList : dictionary;
  }

  if (queryString[0] === "?") {
    queryString = queryString.slice(1);
  }

  const pairs = queryString.split("&");

  pairs.forEach((pair) => {
    pair = pair.split("=");
    const key = pair[0];
    const value = decodeURIComponent(pair[1]);

    if (key) {
      dictionary.set(key, value);
      queryList.push({ key, value });
    }
  });

  if (wantList) return queryList;
  else return dictionary;
};

export const sendToLogin = () => {
  window.location.href = LOGIN_ROUTE;
};

export default composeRoute;
